<!-- declared up here so the form's (ngSubmit) can be guarded too: submit is a form button, so pressing it submits the form -->
@let isSubmitting = isSubmitting$ | async;
<div class="dialog--title"
  cdkDrag
  cdkDragHandle
  cdkDragRootElement=".cdk-overlay-pane"
  [cdkDragFreeDragPosition]="position"
  (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{(!data.showSubmitTime ? data.sysText.submitIntermittentTime_title : data.sysText.submitTime_title) | titlecase}}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="close(false)" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <div class="main-container">
    <form id="form" [formGroup]="form" (ngSubmit)="!isSubmitting && onSubmit()">
      @if (data.submitIntermittentTimeDialog.showLeavePickList) {
        <app-employee-case-picker
          [control]="employee"
          [label]="data.sysText.employeeCase"
          [icon]="'person'"
          [group]="form"
          [isLoadingEmployee$]="isLoadingEmployee$"
          [employeeCaseOptions]="this.data.submitIntermittentTimeDialog.employeeCaseOptions">
        </app-employee-case-picker>
      }

      <div>
        @for (timeSubmittal of timeSubmittals.controls; track timeSubmittal; let i = $index) {
          <div class="row__container" formArrayName="timeSubmittals">
            <ng-container [formGroupName]="i">
              <div class="field__container wrap">
                <div class="field-container">
                  <mat-icon [ngClass]="{ focus: input.focused }">calendar_today</mat-icon>
                  <mat-form-field color="accent">
                    <mat-label>{{ (!data.showSubmitTime ? data.sysText.dateFieldLabelA : data.sysText.dateFieldLabelB) | titlecase }}</mat-label>
                    <input matInput [matDatepicker]="picker" [formControl]="timeSubmittal.controls.submittedDate" #input="matInput" (paste)="onPasteIntoField($event, i)" autocomplete="off"/>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker [touchUi]="isMobile$ | async"></mat-datepicker>
                    <mat-hint class="hint-blue">
                      @if (timeSubmittal.controls.timeSubmittalWarn.value) {
                        <p class="mat-hint-combined">
                          {{ timeSubmittal.controls.timeSubmittalWarn.value + ' ' +
                          data.sysText.timeSubmittalWarn1 + ' ' +
                          (timeSubmittal.controls.submittedDate.value | date) + '. ' +
                          data.sysText.timeSubmittalWarn2 }}
                        </p>
                      }
                      @if (timeSubmittal.controls.sameDateWarn.value) {
                        <p class="mat-hint-combined">
                          {{ data.sysText.sameDateWarn1 + ' ' +
                          (timeSubmittal.controls.sameDateWarn.value | date) + ' ' +
                          data.sysText.sameDateWarn2 }}
                        </p>
                      }
                      @if (timeSubmittal.controls.otherLeavesWarn.value) {
                        <p class="mat-hint-combined">
                          {{ data.sysText.otherLeavesWarn }}
                        </p>
                      }
                    </mat-hint>
                    @if (timeSubmittal.controls.submittedDate.errors?.msError) {
                      <mat-error>{{ $safeNavigationMigration(timeSubmittal.controls.submittedDate.errors?.msError) | replaceBankNames: employee.value }}</mat-error>
                    }
                    @if (timeSubmittal.controls.submittedDate.errors?.required && !timeSubmittal.controls.submittedDate.errors?.matDatepickerParse) {
                      <mat-error>{{ data.sysText.required | capitalizefirst }}</mat-error>
                    }
                    @if (timeSubmittal.controls.submittedDate.errors?.matDatepickerParse) {
                      <mat-error>{{ data.sysText.invalidDateError }}</mat-error>
                    }
                    @if (timeSubmittal.controls.submittedDate.errors?.dateRangeInvalid) {
                      <mat-error>{{ data.sysText.dateRangeInvalid1 + ' ' + (employee.value.startDate | date)  + ' ' + data.sysText.dateRangeInvalid2 + ' ' + (employee.value.endDate | date) }}.</mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="field-container hours">
                  <mat-form-field color="accent">
                    <mat-label>{{ data.sysText.hoursFieldLabel | titlecase }}</mat-label>
                    <input matInput #input="matInput" type="number" [formControl]="timeSubmittal.controls.totalTimeSubmitted" (paste)="onPasteIntoField($event, i)" autocomplete="off"/>
                    <!-- mat hint for spacing -->
                    @if (!timeSubmittal.controls.notFullDayWarn.value) {
                      <mat-hint></mat-hint>
                    }
                    @if (timeSubmittal.controls.notFullDayWarn.value === true) {
                      <mat-hint class="caption hint-red">{{ data.sysText.notFullWorkdayError }}</mat-hint>
                    }
                    @if (timeSubmittal.controls.totalTimeSubmitted.errors?.msError) {
                      <mat-error>{{ $safeNavigationMigration(timeSubmittal.controls.totalTimeSubmitted.errors?.msError) | replaceBankNames: employee.value }}</mat-error>
                    }
                    @if (timeSubmittal.controls.totalTimeSubmitted.errors?.required) {
                      <mat-error>{{ data.sysText.required | capitalizefirst }}</mat-error>
                    }
                    @if (timeSubmittal.controls.totalTimeSubmitted.errors?.pattern) {
                      <mat-error>{{ data.sysText.invalidHoursError | capitalizefirst }}</mat-error>
                    }
                    @if (timeSubmittal.controls.totalTimeSubmitted.errors?.hoursGreaterThan24) {
                      <mat-error>{{ data.sysText.hoursGreaterThan24Error | capitalizefirst }}</mat-error>
                    }
                  </mat-form-field>
                </div>
                @if (someBanksFullDayIncrementSub.value) {
                  <div class="check-container">
                    <mat-checkbox
                      class="full-day-check"
                      [formControl]="timeSubmittal.controls.isFullDay">{{ data.sysText.fullWorkday + (timeSubmittal.controls.fullDayIncrement.value != null ? ' (' + timeSubmittal.controls.fullDayIncrement.value + 'h' + ')'  : '')}}
                    </mat-checkbox>
                  </div>
                }
              </div>
              <div>
                @if (timeSubmittals.controls.length > 1) {
                  <button
                    mat-icon-button
                    type="button"
                    [attr.aria-label]="data.sysText.remove_ariaLabel"
                    [disableRipple]="true"
                    (click)="onRemoveTimeSubmittal(i)">
                    <mat-icon class="no-margin" [ngClass]="{'accent': true}">close</mat-icon>
                  </button>
                }
              </div>
            </ng-container>
          </div>
        }
      </div>
    </form>

    <div class="bottom-section">
      <div aria-live="polite">
        @if (timeSubmittals.errors?.msError) {
          <mat-error class="mse-form-error caption bottom-hint">{{ $safeNavigationMigration(timeSubmittals.errors?.msError) | replaceBankNames: employee.value }}</mat-error>
        }
      </div>
      <div class="buttons-container" [ngClass]="{ 'multiple-hours': timeSubmittals.controls.length > 1 }">
        <button
          #addTimeButton
          (click)="onAddTimeSubmittal()"
          mat-flat-button
          form="form"
          type="button"
          color="accent"
          class="button">
          {{data.sysText.addAdditionalTime | uppercase}}
        </button>
        <button
          (click)="onAddFromClipboard()"
          mat-flat-button
          form="form"
          type="button"
          color="accent"
          class="button"
          [disabled]="disableClipboardButton"
          [matTooltip]="disableClipboardButton ? data.sysText.addFromClipboardMessage : null"
          [matTooltipShowDelay]="500"
          matTooltipPosition="above">
          {{data.sysText.addFromClipboard | uppercase}}
        </button>
      </div>
      @if (someBanksFullDayIncrementSub.value && !allBanksFullDayIncrementSub.value) {
        <mat-hint class="bottom-hint full-day caption hint-blue">{{ data.sysText.someBanksFullDayIncRestrictHint }}</mat-hint>
      }
      @if (allBanksFullDayIncrementSub.value) {
        <mat-hint class="bottom-hint full-day caption hint-blue">{{ data.sysText.allBanksFullDayIncRestrictHint }}</mat-hint>
      }
    </div>

    @if (hoursTakenWarning) {
      <mat-hint class="mat-form-field hint-red bottom-hint">
        {{ (data.sysText.hoursTakenWarning1 | capitalizefirst) + ' ' + employee.value.remainingBank1Leave + ' ' + data.sysText.hoursTakenWarning2 + ' ' + hoursTakenWarning + ', ' + data.sysText.hoursTakenWarning3 + '.' }}
      </mat-hint>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (showNotificationToggle) {
    <div class="slide-container">
      <app-slide-toggle
        [control]="form.controls.sendNotification"
        [isDisabled]="(isSubmitting$ | async)"
        [label]="data.sysText.submitIntermittentTime_sendNotif">
      </app-slide-toggle>
    </div>
  }

  <div>
    @if (!(isMobile$ | async)) {
      <button
        mat-stroked-button
        class="button"
        form="form"
        type="button"
        color="accent"
        [disabled]="isSubmitting"
        (click)="close(false)">
        {{data.sysText.cancel}}
      </button>
    }
    <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the (ngSubmit) guard blocks
    resubmits. as a form button, pressing it submits the form -->
    <button
      mat-stroked-button
      form="form"
      type="submit"
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      disabledInteractive
      [showProgress]="isSubmitting"
      [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null">
      {{data.sysText.submit}}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>
  </div>
</mat-dialog-actions>